import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PDFView from './pdfview';

class Popup extends Component {
    constructor(props) {
        super(props);
    }

    handleClose() {
        this.props.getResult();
    }

    render() {
        return (
            <div>
                <div style={{ position: "fixed" }}>
                    <Modal show="show" size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered>
                        <Modal.Header>
                            <Modal.Title><h5>PREVIEW SOA</h5></Modal.Title>
                        </Modal.Header>
                        <div style={{ height: "395px", width: "100%", overflow: "auto", position: "relative" }}>
                            <Modal.Body>
                                <PDFView
                                    pageNum={this.props.pageNum}
                                />
                            </Modal.Body>
                        </div>
                        <Modal.Footer>
                            <Button variant="warning" onClick={this.handleClose.bind(this)}>
                                Close
                        </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div >
        );
    }
}
export default Popup;